/*
 * Purpose: Client API — mission integration discovery (web search + safe convert)
 * Last modified: 2026-06-28 | Agent
 * Completeness: 92
 */
import type { IntegrationDiscoveryResult } from './types';

export async function discoverIntegrationsForMission(input: {
  missionSessionId: string;
  outcome: string;
  interpretedGoal: string;
  gaps?: string[];
  existingCatalog?: string;
}): Promise<IntegrationDiscoveryResult> {
  try {
    const res = await fetch('/api/integrations/discover', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(input),
    });

    if (res.status === 401) {
      return {
        ok: false,
        proposals: [],
        message: 'Sign in to run integration discovery',
        action: { label: 'Sign in', href: '/auth/sign-in' },
      };
    }

    const body = (await res.json()) as IntegrationDiscoveryResult & { error?: string };
    if (!res.ok) {
      return {
        ok: false,
        proposals: [],
        message: body.error ?? body.message ?? `Discovery failed (${res.status})`,
        action: body.action,
      };
    }

    return body;
  } catch {
    return {
      ok: false,
      proposals: [],
      message: 'Discovery unavailable offline',
    };
  }
}
